import Product from "../components/Home/Product";
import ProductInput from "../components/Home/ProductInput";

function Home(){
    return(
        <main className="py-16">
            <div className="productWrapper">
            <Product />
            <ProductInput />
            </div>
        </main>
    );
}
export default Home;